import { GetOfferNavigationLinkPropertiesInterface } from './getOfferNavigationLink.types'

import { offerTabSettings } from '../../navigation/NavMenuData'
import { getOfferTabLink } from '../index'

// TODO: think about function name
// TODO: think about refactor all place with `getOfferTabLink`
export const getOfferNavigationLink = ({ advertiserAlias, model, active }: GetOfferNavigationLinkPropertiesInterface) =>
  getOfferTabLink(advertiserAlias, model, active ? offerTabSettings.links : offerTabSettings.activation)
